import type { ArticleType } from '@/types/ArticleType';
import mapWpPosts from '@/utils/functions/wordpress/mapWpPosts';
import wpApi from '@/utils/functions/wordpress/wpApi';

const fetchPostsByCategory = async (slug: string, limit = 25, page = 1): Promise<ArticleType[]> => {
    const result = await wpApi()
        .posts()
        .param('category_slug', slug)
        .perPage(limit)
        .page(page)
        .orderby('date')
        .order('desc')
        .embed();
    return mapWpPosts(result);
};

export default fetchPostsByCategory;
